// extracted by mini-css-extract-plugin
module.exports = {"key":"styles_key__1Tf-z"};